
//TODO: È un po' brutto
export function translateEnumAssetState(enumValue: any) {

    if (enumValue === "AVAILABLE")
        return "Disponibile"

    if (enumValue === "NEGOTIATING")
        return "In contrattazione"

    if (enumValue === "NOT_AVAILABLE")
        return "Non disponibile"

    return "/"
}

export function translateAssetType(enumValue: any) {

    if (enumValue === "WAREHOUSE_OR_STORE")
        return "Negozio/Magazzino"

    if (enumValue === "PLOT_OF_LAND")
        return "Terreno"
    
    return "/"
}
